import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  fomData: {
    month: 0,
    brandData: {
      name: '',
      description: '',
      logo: '',
    },
    details: {
      brandData: {
        name: '',
        description: '',
        logo: '',
      },
      quote: {
        author: '',
        text: '',
        authorPhoto: '',
      },
      sliderMedia: [],
      headerLogo: '',
      descriptionTitle: '',
      brandPhotos: [],
    },
    sliderMedia: [],
    perfume: {
      brand: '',
      id: 0,
      img: '',
      name: '',
    },
    notesNames: [],
    monthName: '',
    name: '',
    aLaCartId: 0,
    version: 'v3',
    volumes: [],
    listOfPOM: [],
    description: '',
    year: 0,
  },
  productData: {
    upchargePrice: null,
    activeVolumeIndex: 0,
    volumes: [],
    isVisible: true,
  },
}

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)

export const setFomData = (state, payload) => (
  object.set(state, 'fomData', payload)
)

export const setProductData = (state, payload) => (
  { ...state, productData: { ...state.productData, ...payload }, isFetching: false }
)

export const setActiveVolumeIndex = (state, payload /* index */) => (
  object.updateIn(state, 'productData', (productData) => ({
    ...productData,
    activeVolumeIndex: payload,
  }))
)
